const Quote = () => (
  <div className="main-content quote">
    <h1>
      Mathematics is not about numbers, equations, computations, or algorithms:
      it is about understanding. &mdash;William Paul Thurston
    </h1>
  </div>
);

export default Quote;
